import Titol from 'components/3catinfo/Titol';
import { getSlugTag } from 'utils/3catinfo/seccioHelper';

export default function Continuallegint(props) {
    const { titol, titolTema, tagPrincipal } = props;
    let text = titol + titolTema;
    const ariaLabel = titolTema ? `Mostra-ho tot ${titolTema}` : 'Mostra-ho tot';
    const mostrarBotoMesItems = !!tagPrincipal;
    const type = mostrarBotoMesItems ? 'web_actualitat_seccio' : '';
    const slug = mostrarBotoMesItems ? getSlugTag(tagPrincipal) : '';

    return (
        <div>
            <Titol
                tag='h3'
                titol={text}
                icona='fletxa_simple_dreta'
                text='Mostra-ho tot'
                ariaLabel={ariaLabel}
                linkTipus={type}
                slug={slug}
                mostrarBotoMesItems={mostrarBotoMesItems}
            />
        </div>
    );
}
